// FAQ items are localized: each item references dict keys (q/a) resolved at
// render time via the i18n t() function. Add a new item by adding a row here
// plus its `faq.qN` / `faq.aN` strings to every language in src/i18n/dict.ts.
export interface FaqItem {
  /** Dict key for the question. */
  qKey: string;
  /** Dict key for the answer. */
  aKey: string;
}

export const FAQ: FaqItem[] = [
  { qKey: "faq.q1", aKey: "faq.a1" },
];
